/*
 * @Author: caiqin.xie
 * @since: 2023-06-09 14:56:39
 * @lastTime: 2023-11-07 16:09:31
 * @LastEditors: caiqin.xie
 * @message: 博客列表第一页数据，pad和移动端数据
 */
import React, { Fragment } from "react";
import HostBanner from "../HostBanner";
import GameBanner from "../GameBanner";
import BlogItem from "../BlogItem";
import RecommendBlog from "../RecommendBlog";
import styles from "../../index.module.scss";
import { IBlogItem } from '@/common/types'

interface IProps {
  blogList: IBlogItem[]; // 博客列表
  hostBanner: Record<string, any>; // 主机banner
  ctry: string;
  words: Record<string, string>;
  gameBanner: Record<string, any>; // 游戏banner
  recommendBlogList: IBlogItem[]; // 推荐博客列表
}

const BlogList = (props:IProps) => {
  const {blogList, hostBanner, ctry, words, gameBanner, recommendBlogList} = props

  return (
    <>
      <RecommendBlog recommendBlogList={recommendBlogList} ctry={ctry} words={words} />
      
      <GameBanner gameBanner={gameBanner} ctry={ctry} words={words} />

      {blogList && blogList.map((item,index) => (
        <Fragment key={item.id}>
          <a
            href={`/${ctry}/blog/${item.seoUrl}`}
            className={styles['link-blog']}>
            <BlogItem
              type={'normal'}
              blogData={item}
              className={styles['custom-blog']}
              picClassName={styles['custom-blog-pic']}
              itemClassName={styles['custom-blog-item']} />
          </a>
          {/* {index === 0 && (
            <GameBanner gameBanner={gameBanner} ctry={ctry} words={words} />
          )} */}
          {index === 2 && (
            <HostBanner hostBanner={hostBanner} ctry={ctry} words={words} />
          )}
        </Fragment>
      ))}
    </>
  )
}
export default BlogList

